import React from "react";
import AssetEnterreListManager from "../../manager/assetEnterre";

const AssetEnterrePage = () => {
    return (
        <AssetEnterreListManager/>
    )
}
export default AssetEnterrePage;